import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TalentInfluencerDetailsForEdit.graphql';
import { Query, QuerytalentInfluencerDetailsForEditArgs } from '../../__generated__/globalTypes';

export const useTalentInfluencerDetailsForEditQuery = (
  options?: QueryHookOptions<Query, QuerytalentInfluencerDetailsForEditArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytalentInfluencerDetailsForEditArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTalentInfluencerDetailsForEditLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytalentInfluencerDetailsForEditArgs>
): QueryResult<Query, QuerytalentInfluencerDetailsForEditArgs> & {
  getTalentInfluencerDetailsForEdit: LazyQueryExecFunction<Query, QuerytalentInfluencerDetailsForEditArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTalentInfluencerDetailsForEdit, result] = useLazyQuery<Query, QuerytalentInfluencerDetailsForEditArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getTalentInfluencerDetailsForEdit, ...result };
};

export const useTalentInfluencerDetailsForEditPromiseQuery = () => {
  const client = useApolloClient();

  const getTalentInfluencerDetailsForEdit = useCallback(
    (options?: Omit<QueryOptions<QuerytalentInfluencerDetailsForEditArgs, Query>, 'query'>) =>
      client.query<Query, QuerytalentInfluencerDetailsForEditArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTalentInfluencerDetailsForEdit };
};
// Suspense Query Hooks
export const useTalentInfluencerDetailsForEditSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytalentInfluencerDetailsForEditArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytalentInfluencerDetailsForEditArgs>(QUERY, {
    ...options
  });

  return result;
};
